<template>
  <section class="home-cta">
    <div class="container">
      <div class="cta-grid">
        <div class="cta-card order-card" data-aos="fade-up" data-aos-duration="800">
          <div class="cta-icon">
            <i class="ri-smartphone-line"></i>
          </div>
          <h3>Order Online</h3>
          <p>Enjoy your favorites at home. Your favorite food is just a click away.</p>
          <a 
            href="#"
            class="cta-link"
          >
            Coming Soon <i class="ri-arrow-right-up-line"></i>
          </a>
        </div>
        <div class="cta-card catering-card" data-aos="fade-up" data-aos-duration="800" data-aos-delay="200">
          <div class="cta-icon">
            <i class="ri-cake-3-line"></i>
          </div>
          <h3>Catering</h3>
          <p>Creative menus, exceptional service. Make your event unforgettable with our catering packages.</p>
          <a 
            href="#"
            class="cta-link"
          >
            Coming Soon <i class="ri-arrow-right-up-line"></i>
          </a>
        </div>
        <div class="cta-card dinein-card" data-aos="fade-up" data-aos-duration="800" data-aos-delay="400">
          <div class="cta-icon">
            <i class="ri-store-2-line"></i>
          </div>
          <h3>Dine In</h3>
          <p>Casual, family-friendly atmosphere. Visit us for a fresh, flavorful experience.</p>
          <a href="#location" class="cta-link" @click.prevent="scrollToLocation">
            Get Directions <i class="ri-arrow-right-up-line"></i>
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "HomeCTA",
  setup() {
    const scrollToLocation = () => {
      const el = document.getElementById('location');
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };
    return { scrollToLocation };
  },
});
</script>

<style lang="scss" scoped>
.home-cta {
  padding: 0 0 120px;
  background: #141414;

  .cta-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 24px;
  }

  .cta-card {
    position: relative;
    padding: 48px 36px;
    border-radius: 24px;
    border: 1px solid rgba(255, 255, 255, 0.06);
    overflow: hidden;
    transition: all 0.4s ease;

    &::before {
      content: '';
      position: absolute;
      inset: 0;
      opacity: 0;
      transition: opacity 0.4s ease;
      z-index: 0;
    }

    &:hover {
      transform: translateY(-8px);
      border-color: rgba(181, 255, 0, 0.15);

      &::before {
        opacity: 1;
      }

      .cta-link {
        color: #b5ff00;
        i {
          transform: translate(3px, -3px);
        }
      }
    }

    > * {
      position: relative;
      z-index: 1;
    }

    &.order-card {
      background: linear-gradient(135deg, #1a1f14 0%, #141414 100%);
      &::before {
        background: radial-gradient(circle at top left, rgba(181, 255, 0, 0.06), transparent 60%);
      }
    }

    &.catering-card {
      background: linear-gradient(135deg, #1a1714 0%, #141414 100%);
      &::before {
        background: radial-gradient(circle at top left, rgba(255, 180, 0, 0.06), transparent 60%);
      }
    }

    &.dinein-card {
      background: linear-gradient(135deg, #14171a 0%, #141414 100%);
      &::before {
        background: radial-gradient(circle at top left, rgba(0, 180, 255, 0.06), transparent 60%);
      }
    }

    .cta-icon {
      width: 56px;
      height: 56px;
      background: rgba(181, 255, 0, 0.1);
      border: 1px solid rgba(181, 255, 0, 0.15);
      border-radius: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 24px;
      i {
        font-size: 26px;
        color: #b5ff00;
      }
    }

    h3 {
      font-size: 22px;
      font-weight: 700;
      color: #ffffff;
      margin-bottom: 12px;
    }

    p {
      font-size: 15px;
      color: rgba(255, 255, 255, 0.5);
      line-height: 1.6;
      margin-bottom: 24px;
    }

    .cta-link {
      display: inline-flex;
      align-items: center;
      gap: 8px;
      color: rgba(255, 255, 255, 0.7);
      font-size: 15px;
      font-weight: 600;
      text-decoration: none;
      transition: all 0.3s ease;
      i {
        transition: transform 0.3s ease;
      }
    }
  }
}

@media (max-width: 991px) {
  .home-cta {
    padding: 0 0 80px;
    .cta-grid {
      grid-template-columns: 1fr;
      gap: 16px;
    }
    .cta-card {
      padding: 36px 28px;
    }
  }
}
</style>
